import { render, staticRenderFns } from "./newly.vue?vue&type=template&id=7f551010&scoped=true"
import script from "./newly.vue?vue&type=script&lang=js"
export * from "./newly.vue?vue&type=script&lang=js"
import style0 from "./newly.vue?vue&type=style&index=0&id=7f551010&prod&lang=less"
import style1 from "./newly.vue?vue&type=style&index=1&id=7f551010&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f551010",
  null
  
)

export default component.exports